export const findInProjectStaffData = (project, projectStaffData) => {
  return project.find(staff => staff.staff?.id === projectStaffData.staffId)
}
